<mat-card appearance="outlined" class="syn-card">
    <mat-card-header>
        <mat-card-title>
            Historique des modifications {{ title }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="filtersForm"
              (ngSubmit)="onSubmit($event)"
              fxFlexFill
              fxLayout="row"
              fxLayout.sm="column"
              fxLayoutAlign="start end"
              fxLayoutAlign.sm="start stretch"
              fxLayoutGap="45px">
            <mat-form-field fxFlex fxGrow="2" appearance="outline">
                <mat-label>Filtrer par champs modifiés</mat-label>
                <mat-chip-grid #updatedFieldsList [disabled]="loading" aria-label="Updated fields list">
                    <mat-chip-row *ngFor="let updatedField of updatedFields" (removed)="removeUpdatedField(updatedField)">
                        {{ updatedField }}
                        <button matChipRemove>
                            <mat-icon svgIcon="cancel"></mat-icon>
                        </button>
                    </mat-chip-row>

                    <input placeholder="Les champs doivent être saisis en anglais"
                           [matChipInputFor]="updatedFieldsList"
                           [matChipInputSeparatorKeyCodes]="filterUpdatedFieldSeparatorKeysCodes"
                           (matChipInputTokenEnd)="addUpdatedField($event)"/>
                </mat-chip-grid>
            </mat-form-field>

            <button class="hidden" type="submit"></button>

            <mat-form-field fxFlex fxGrow="2" appearance="outline">
                <mat-label>Intervalle de temps</mat-label>
                <mat-date-range-input formGroupName="range" [rangePicker]="picker">
                    <input #startInput matStartDate formControlName="from" placeholder="Début">
                    <input #endInput matEndDate formControlName="to" placeholder="Fin">
                </mat-date-range-input>

                <button *ngIf="filtersForm.get('range.from').value || filtersForm.get('range.to').value"
                        (click)="clearPickerRange($event)"
                        matSuffix mat-icon-button>
                    <mat-icon svgIcon="cancel"></mat-icon>
                </button>

                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

                <mat-date-range-picker #picker></mat-date-range-picker>

                <mat-error *ngIf="filtersForm.get('range.from').dirty && !filtersForm.get('range.from').valid">Date de début invalide.</mat-error>
                <mat-error *ngIf="filtersForm.get('range.to').dirty && !filtersForm.get('range.to').valid">Date de fin invalide.</mat-error>
            </mat-form-field>

            <syn-picker formControlName="updatedBy"
                        placeholder="Mis à jour par"
                        [content]="updatedBy$"
                        [contentLoader]="updatedByContentLoader"
                        [itemTemplate]="userItemTemplate"
                        fxFlex fxGrow="1">
            </syn-picker>
        </form>

        <div class="scroll-wrapper"
             infiniteScroll
             [scrollWindow]="false"
             [infiniteScrollDistance]="2"
             [infiniteScrollThrottle]="50"
             (scrolled)="loadNextPage()">
            <table *ngIf="logs.length > 0; else noLogs"
                   mat-table
                   [dataSource]="logs">
                <ng-container matColumnDef="updatedAt">
                    <th mat-header-cell *matHeaderCellDef>Modifié le</th>
                    <td mat-cell *matCellDef="let log">{{ log.when | date:'d MMMM y à HH:mm' }}</td>
                </ng-container>
                <ng-container matColumnDef="updatedBy">
                    <th mat-header-cell *matHeaderCellDef>Modifié par</th>
                    <td mat-cell *matCellDef="let log">
                        <syn-user-avatar
                            [user]="log.$who"
                            [showLegend]="true"
                            [clickable]="false"
                            [caption]="log.$who.id"
                        ></syn-user-avatar>
                    </td>
                </ng-container>
                <ng-container matColumnDef="updatedFields">
                    <th mat-header-cell *matHeaderCellDef>Champs modifiés</th>
                    <td mat-cell *matCellDef="let log">
                        <mat-chip-listbox>
                            <mat-chip disableRipple *ngFor="let updatedField of log.updatedFields | slice:0:MAX_DISPLAYED_UPDATED_FIELDS" [disableRipple]="true">
                                {{ updatedField }}
                            </mat-chip>
                            <ng-container *ngIf="(log.updatedFields | slice:MAX_DISPLAYED_UPDATED_FIELDS) as remainingFields">
                                <mat-chip disableRipple *ngIf="remainingFields.length > 0" [disableRipple]="true" [matTooltip]="remainingFields.join(', ')">
                                    + {{ remainingFields.length }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-listbox>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row
                    matRipple
                    *matRowDef="let log; columns: displayedColumns;"
                    [class.mat-row--selected]="log.id === selectedLogId"
                    (click)="selectLog(log)"
                ></tr>
            </table>
        </div>

        <div *ngIf="loading" class="progress-spinner" fxFlexFill fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
            <mat-spinner color="accent" diameter="40"></mat-spinner>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #noLogs>
    <p class="no-logs mat-subtitle-2">Aucune modification trouvée.</p>
</ng-template>

<ng-template #fieldItemTemplate
             let-content="content">
    {{ content }}
</ng-template>

<ng-template #fieldChipTemplate
             let-content="content">
    {{ content }}
</ng-template>

<ng-template #userItemTemplate
             let-id="content.id"
             let-firstName="content.firstName"
             let-lastName="content.lastName"
             let-fullName="content.fullName">
    <div>
        <div class="template_header" *ngIf="fullName">{{ fullName }}</div>
        <div class="template_header" *ngIf="!fullName">{{ firstName }} {{ lastName }}</div>
        <div class="template_subheader">{{ id }}</div>
    </div>
</ng-template>
